/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { InterviewerOut } from './interviewerOut';
import type { ScorecardFillOutValues } from './scorecardFillOutValues';

export interface ScorecardFillOut {
  id: string;
  job_candidate_id: string;
  scorecard_definition_id: string;
  definition_version_id: string;
  interviewer: InterviewerOut;
  event_kind: string;
  external_event_id: string | null;
  conversation_id: string | null;
  source: string;
  values: ScorecardFillOutValues;
  submitted_at: string | null;
  confirmed_by_user_id: string | null;
  created_at: string;
  updated_at: string;
}
